import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';
import { DateTime } from 'scaleflow/utils/date-time';

class RoadmapTableInitiativeWorkstreamsWorkstreamRoute extends Route {
  @service store;

  today = DateTime.now().add(2, 'days').format('YYYY-MM-DD');
  six_months_ago = DateTime.now().subtract(6, 'months').format('YYYY-MM-DD');

  model(params) {
    return this.store.query('tfo', {
      filter: {
        archived: true,
        after: this.six_months_ago,
        before: this.today,
        ...params, //{workstream:id}
      },
    });
  }
}

export default instrumentRoutePerformance(
  RoadmapTableInitiativeWorkstreamsWorkstreamRoute,
);
